import type { BuildType } from './ApiService';
import type { Cmi5Course, Cmi5LaunchResponse, Cmi5RegistrationProgress } from '@/apiTypes/Cmi5Types';

export const cmi5ApiEndpoints = (build: BuildType) => ({
    listCmi5Courses: build.query<Cmi5Course[], void>({
        query: () => 'cmi5/courses',
        providesTags: ['Cmi5Courses'],
    }),
    /** Invalidated when the lesson player closes. */
    getMyCmi5Registrations: build.query<Cmi5RegistrationProgress[], void>({
        query: () => 'cmi5/registrations/me',
        providesTags: ['Cmi5Registrations'],
    }),
    launchCmi5Course: build.mutation<Cmi5LaunchResponse, string>({
        query: id => ({ url: `cmi5/courses/${id}/launch`, method: 'POST' }),
        invalidatesTags: ['Cmi5Registrations'],
    }),
    favoriteCmi5Course: build.mutation<void, string>({
        query: id => ({ url: `cmi5/courses/${id}/favorite`, method: 'POST' }),
        invalidatesTags: ['Favorites'],
    }),
});
